export interface Faq {
  q: string
  a: string
}

export const faqs: Faq[] = [
  {
    q: 'How do I receive Boxing Coach Ready after purchase?',
    a: 'You receive access to the digital materials after completing your purchase. Everything is delivered as PDF resources so you can begin using the material immediately.',
  },
  {
    q: 'What levels does Boxing Coach Ready cover?',
    a: 'The system includes material for beginners, intermediate athletes and advanced athletes. It also includes regressions and progressions so the coach can adjust the same objective to the athlete’s current level.',
  },
  {
    q: 'Is this only for competitive boxing coaches?',
    a: 'No. It can be used by coaches working with complete beginners, recreational boxers, fitness-oriented boxing participants, intermediate athletes, technically developing boxers and experienced competitive athletes.',
  },
  {
    q: 'Can coaches use it in any country?',
    a: 'Yes. The coaching structure, drills, technical principles and session systems are designed for international use. Coaches remain responsible for following local safety rules, competition regulations and organizational requirements.',
  },
  {
    q: 'Can I edit the material?',
    a: 'The material is delivered as ready-to-use PDF resources. Editable source files are not included.',
  },
  {
    q: 'Is this a video course?',
    a: 'No. Boxing Coach Ready is a PDF-based professional coaching system. It focuses on structured sessions, drills, coaching cues, corrections, progressions, conditioning, tactical development and ready-reference material.',
  },
  {
    q: 'What if I already know boxing?',
    a: 'That is exactly the point. Boxing Coach Ready is not designed to replace your boxing knowledge. It is designed to eliminate the need to keep turning that knowledge into complete sessions from scratch.',
  },
  {
    q: 'Do I need special equipment?',
    a: 'No single setup is required for the entire system. Different sessions use different equipment, and Volume 6 includes adaptations for situations where bags, pads or partners are unavailable, or space and equipment are limited.',
  },
  {
    q: 'Is everything ready to use immediately?',
    a: 'Yes. The material is designed so you can choose the relevant session, review the objective and structure, and take it directly into the gym.',
  },
]
